import styleSheet from "./style.module.scss";
import { deleteCookie, setCookie } from "../../../../utils/cookie";
import {
  getAuthDetails,
  setAuthToken,
  setUserDetails,
} from "../../../../feature/auth-slice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { MenuProps } from "./app-menu-interface";
import SyIcon from "../../../../shared/components/sy-icon";

import {
  getUserImage,
  resetAuthSlice,
  setCompanyDetails,
  setIsAdmin,
  setIsCitizen,
  setIsVolunteer,
  setOrbitDetails,
  setTempUserData,
  setUserImage,
} from "../../../../feature/auth-slice/auth-slice";
import { getImageDetails } from "../../../../feature/image-slice";
import OrbPopover from "../../../../shared/components/orb-popover";
import SyPopup from "../../../../shared/components/sy-model";
import { useMutation } from "@tanstack/react-query";
import citizenService from "../../services/citizen-service";
import { useEffect, useState } from "react";
import authService from "../../../auth-module/services/auth-service";
import { removeLocalData } from "../../../../utils/localstorage";
import {
  setAdminStuff,
  setHeader,
  setMainOrbit,
  setMaps,
  setOrbitRotate,
  setOrbitSearch,
  setSelectOrbit,
} from "../../../../feature/orbit-slice/orbit-slice";
import OrbAvatar from "../../../../shared/components/orb-avatar";

const AppMenu = ({ onClickProfile, onClickClose, onAddAccount }: any) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [menuDetails, setMenuDetails] = useState<any>(null);
  const [openProfile, setOpenProfile] = useState<any>(false);
  const authDetails = useSelector(getAuthDetails);
  const userImage = useSelector(getUserImage);
  const imageDetails = useSelector(getImageDetails);

  const onClickLogOut = () => {
    removeLocalData("orbit_userDetails");
    removeLocalData("volenteer");
    deleteCookie("auth_token");

    resetOrbitSlice();
    resetAuthSlice();

    onClickClose();
    navigate("/");
  };

  const resetOrbitSlice = () => {
    dispatch(setMainOrbit(null));
    dispatch(setSelectOrbit(null));
    dispatch(setMaps(0));
    dispatch(setAdminStuff(false));
    dispatch(setOrbitRotate(false));
    dispatch(setOrbitSearch(""));
    dispatch(setHeader(true));
  };
  
  const resetAuthSlice = () => {
    dispatch(setAuthToken(""));
    dispatch(setUserDetails({}));
    dispatch(setCompanyDetails({}));
    dispatch(setTempUserData({}));
    dispatch(setOrbitDetails({}));
    dispatch(setUserImage(""));
    dispatch(setIsAdmin(false));
    dispatch(setIsCitizen(false));
    dispatch(setIsVolunteer(false));
  };

  return (
    <>
      <div className={`${styleSheet.admn_bg} d-flex flex-wrap mt-3 p-3`}>
        <div className="d-flex ">
          <OrbAvatar
            file={authDetails?.user_image}
            className={`${styleSheet.profile_style}`}
          />
          <div role="button" onClick={onClickProfile}>
            <h4 className={`m-0 mt-1 ps-2 mohave-bold ${styleSheet.ellipsis}`}>
              {authDetails?.user_details?.usr_email}
            </h4>
            <p className={`m-0 ps-2 mohave sub-font ${styleSheet.ellipsis}`}>
              {authDetails?.user_details?.usr_name}
            </p>
          </div>
        </div>
        <div
          className={`mt-3 w-100 d-flex align-self-end flex-row`}
          onClick={onClickLogOut}
        >
          <div className="col-10 d-flex pointer">
            <SyIcon name={"power_settings_new"} className={"pt-1 pe-1"} />

            <p role="button" className={`m-0 lh-lg mohave main-font`}>
              Logout
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default AppMenu;
